import React from "react";
import { Row, Col, Glyphicon, OverlayTrigger, Tooltip } from "react-bootstrap";

// formatDate function added by Gerardo
// Alternatives would be:
// A)
//
// ```js
// const startOfThisWeek = new Date(now.setDate(now.getDate() - now.getDay() + 1))
// const dateFormatter = new Intl.DateTimeFormat(
//   'de-DE', {year: 'numeric', month: '2-digit', day: '2-digit' }
// )
// dateFormatter.format(startOfThisWeek)
// ```
//
// (this let the snapshot tests fail on CI for some reason)
// B)
// use of momentjs
//
// TODO: move to momentjs which is nowadays part of the JS code anyway
function formatDate(date) {
  if (date) {
    const currentDate = date.getDate();
    const currentMonth = date.getMonth() + 1; // Months are zero based
    const currentYear = date.getFullYear();

    if (currentDate && currentMonth && currentYear) {
      return `${currentDate}.${currentMonth}.${currentYear}`;
    }
  }
  return undefined;
}

const ProductStatus = ({ productName, salesDataInfo }) => {
  const now = new Date();
  const startOfThisWeek = new Date(
    now.setDate(now.getDate() - now.getDay() + 1),
  );

  const tooltip = <Tooltip id="salesDataInfoIcon">{salesDataInfo}</Tooltip>;

  return (
    <Row>
      <Col xs={12}>
        <p className="content-header">
          Abverkaufsdaten: {`${productName} `}
          <small>
            Stand: {`${formatDate(startOfThisWeek)} `}
            <OverlayTrigger placement="right" overlay={tooltip}>
              <Glyphicon glyph="info-sign" />
            </OverlayTrigger>
          </small>
        </p>
      </Col>
    </Row>
  );
};

export default ProductStatus;
